import React, { Component } from 'react';
import _ from 'lodash';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { Link, withRouter } from 'react-router-dom';

import './stylesheets/OperatedDocumentsPage.css';

import { documentNumberFormatter, rowClassNameFormat, thaiDateFormatter, renderShowsTableTotal } from '../../utils/bootstrapTableFormatters';
import { MergeAttributes } from '../../components/FlatData';
import Loading from '../../components/Loading';
import SimpleModal from '../../components/SimpleModal';

import WorkflowProcessHistory from '../../components/WorkflowProcessHistory';
import WorkflowProcessStore from '../../stores/WorkflowProcessStore';

import PositionFilter from '../../components/documents/filters/PositionFilter';
import StatusFilter from '../../components/documents/filters/StatusFilter';
import DocumentTypeFilter from '../../components/documents/filters/DocumentTypeFilter';

class OperatedDocumentsPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
      isDataFetched: false,
      workflow_processes: [],
      active_position_user_id: '',
      available_statuses: [],
      active_status: '',
      available_document_types: [],
      active_type: 'ทั้งหมด',
      pagination: {},
      searchText: ''
    }
    
    this.stateFormatter = this.stateFormatter.bind(this);
    this.redirectToShowDocumentPage = this.redirectToShowDocumentPage.bind(this);
    this.onClose = this.onClose.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleSubmitSearch = this.handleSubmitSearch.bind(this);
    this.handleChangePosition = this.handleChangePosition.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.handleChangeType = this.handleChangeType.bind(this);
    this.openFullScreenHistory = this.openFullScreenHistory.bind(this);
  }

  componentDidMount() {
    WorkflowProcessStore.request({url: 'workflow_processes?type=operated&page=1'}).then((resp)=>{
      const workflow_processes = _.get(resp.data, 'data', []);
      const available_statuses = _.get(resp.data, 'available_statuses', []);
      const available_document_types = _.get(resp.data, 'available_document_types', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        workflow_processes: workflow_processes,
        available_statuses: available_statuses,
        available_document_types: available_document_types,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    })
  }

  redirectToShowDocumentPage(row, isSelected, e){
    // open new tab
    window.open(`/templates/documents/${row.attributes.document.id}/show/${row.attributes.document_template.id}/wp/${row.id}`);

    // redirect
    // this.props.history.push(`/templates/documents/${row.attributes.document.id}/show/${row.attributes.document_template.id}/wp/${row.id}`);
  }

  stateFormatter(cell, row) {
    return (
      <a href="#" onClick={this.openModal.bind(this, row.id)}>
        {cell}
      </a>
    )
  }

  openModal(workflow_process_id, event){
    event.stopPropagation();

    this.setState({
      open: true,
      workflow_process_id: workflow_process_id,
    });
  }

  onChange(fieldname, value){
    this.setState({
      [fieldname]: value
    })
  }

  onClose(){
    this.setState({
      open: false,
      workflow_process_id: null
    });
  }

  handlePageChange(page, sizePerPage){
    this.setState({isDataFetched: false, workflow_processes: []});
    const { active_status, active_position_user_id, searchText } = this.state;

    WorkflowProcessStore.request({url: `workflow_processes?type=operated&page=${page}&searchText=${searchText}&status=${active_status}&positions_user_id=${active_position_user_id}`}).then((resp)=>{
      const workflow_processes = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        workflow_processes: workflow_processes,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    })
  }

  handleSearchChange(searchText){
    if (searchText.length === 1) { return }
    this.setState({isDataFetched: false, workflow_processes: []});
  const { active_status, active_position_user_id } = this.state;

    WorkflowProcessStore.request({url: `workflow_processes?type=operated&page=1&searchText=${searchText}&status=${active_status}&positions_user_id=${active_position_user_id}`}).then((resp)=>{
      const workflow_processes = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        workflow_processes: workflow_processes,
        pagination: pagination,
        searchText: searchText
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    })
  }

  handleSubmitSearch(){
    this.setState({isDataFetched: false, workflow_processes: []});
    const { searchText, active_position_user_id, active_status, active_type } = this.state;

    WorkflowProcessStore.request({url: `workflow_processes?type=operated&page=1&searchText=${searchText}&positions_user_id=${active_position_user_id}&status=${active_status}&page=1&searchText=${searchText}&document_type=${active_type}`}).then((resp)=>{
      const workflow_processes = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        workflow_processes: workflow_processes,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    })
  }

  _setTableOption(){ 
      if(this.state.isDataFetched){
            return "ไม่มีข้อมูล";
        }else{
            return <Loading />
        }
  }

  handleChangePosition(pu_id){
    this.setState({isDataFetched: false, workflow_processes: []});

    const { active_status, searchText, active_type } = this.state;
    WorkflowProcessStore.request({url: `workflow_processes?type=operated&positions_user_id=${pu_id}&status=${active_status}&page=1&searchText=${searchText}&document_type=${active_type}`}).then((resp)=>{
      const workflow_processes = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});
      
      this.setState({
        active_position_user_id: pu_id,
        workflow_processes: workflow_processes,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }

  handleChangeStatus(status){
    this.setState({isDataFetched: false, workflow_processes: []});

    const { active_position_user_id, searchText, active_type } = this.state;
    WorkflowProcessStore.request({url: `workflow_processes?type=operated&status=${status}&positions_user_id=${active_position_user_id}&page=1&searchText=${searchText}&document_type=${active_type}`}).then((resp)=>{
      const workflow_processes = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});
      
      this.setState({
        active_status: status,
        workflow_processes: workflow_processes,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }

  handleChangeType(document_type){
    this.setState({isDataFetched: false, workflow_processes: []});

    const { active_position_user_id, searchText, active_status } = this.state;
    WorkflowProcessStore.request({url: `workflow_processes?type=operated&status=${active_status}&positions_user_id=${active_position_user_id}&page=1&searchText=${searchText}&document_type=${document_type}`}).then((resp)=>{
      const workflow_processes = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});
      
      this.setState({
        active_type: document_type,
        workflow_processes: workflow_processes,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }
  
  openFullScreenHistory(){
    this.props.history.push(`/full_history/${this.state.workflow_process_id}`);
  }

  render(){
    const total_items_count = _.get(this.state.pagination, 'total_items_count', 0);
    const active_page = _.get(this.state.pagination, 'active_page', 1);
    const options = {
      sizePerPageList: [],
      sizePerPage: 20,
      page: active_page,
      noDataText: this._setTableOption(),
      onRowClick: this.redirectToShowDocumentPage,
      onPageChange: this.handlePageChange,
      onSearchChange: this.handleSearchChange,
      searchDelayTime: 500,
      paginationShowsTotal: renderShowsTableTotal
    };
    var data = [];
    if (!_.isEmpty(this.state.workflow_processes)){
      data = MergeAttributes(this.state.workflow_processes);
    }

    return (
      <div className="inbox">
        <div className='row'>
          <div className='col-7 pr-0'>
            <h4>เอกสารดำเนินการแล้ว</h4>
          </div>
          <div className='col-5 text-right d-none d-lg-block'>
            <Link to='/templates' className='btn btn-success'>ร่างเอกสาร</Link>
          </div>
        </div>

        <PositionFilter 
          active_position_user_id={this.state.active_position_user_id}
          handleChangePosition={this.handleChangePosition} />

        <StatusFilter 
          available_statuses={this.state.available_statuses}
          active_status={this.state.active_status}
          handleChangeStatus={this.handleChangeStatus} />

        {this.state.available_document_types.length > 0 && (
          <div className='row'>
            <div className='col-12'>
              <DocumentTypeFilter 
                active_type={this.state.active_type}
                document_types={this.state.available_document_types}
                handleChangeType={this.handleChangeType} />
            </div>
          </div>
        )}

        <div className='rui-operateddoc'>
          <BootstrapTable 
            data={data}
            remote={ true }
            fetchInfo={{dataTotalSize: total_items_count}}
            search={ true }
            multiColumnSearch={ true }
            options={ options }
            striped
            hover
            pagination
            version='4'
            tableContainerClass={'table-sm'}
            trClassName={rowClassNameFormat}>
            <TableHeaderColumn isKey dataField='id' hidden></TableHeaderColumn>
            <TableHeaderColumn width='200' dataFormat={documentNumberFormatter}>เลขที่หนังสือ</TableHeaderColumn>
            <TableHeaderColumn dataField='topic' columnTitle dataSort={ true }>เรื่อง</TableHeaderColumn>
            <TableHeaderColumn dataField='from_department' columnTitle dataSort={ true }>จาก</TableHeaderColumn>
            <TableHeaderColumn dataField='to_department' columnTitle dataSort={ true }>เรียน</TableHeaderColumn>
            <TableHeaderColumn dataField='type_name' width='100'>ประเภท</TableHeaderColumn>
            <TableHeaderColumn dataField='due_date' dataFormat={ thaiDateFormatter } width='110'>กำหนดแล้วเสร็จ</TableHeaderColumn>
            <TableHeaderColumn dataField='current_state_name' dataSort={ true } dataFormat={this.stateFormatter} width='160'>สถานะ</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <SimpleModal 
          isOpen={this.state.open}
          title="ประวัติการดำเนินการ"
          size={'modal-lg'}
          showSubmitButton={false}
          onClose={this.onClose}>
            <WorkflowProcessHistory id={this.state.workflow_process_id} />

            <div className="modal-footer row">
              <button type='button' className="btn btn-primary pointer" onClick={this.openFullScreenHistory}>ดูแบบเต็มหน้าจอ</button>
              <button type='button' className="btn btn-secondary pointer" onClick={this.onClose}>ปิด</button>
            </div>
        </SimpleModal>
      </div>
    );
  }
}

export default withRouter(OperatedDocumentsPage);


// WEBPACK FOOTER //
// ./src/pages/documents/OperatedDocumentsPage.js